import AutoLinkText from './AutoLinkText';

export default AutoLinkText;
export type { IAutoLinkTextProps } from './AutoLinkText';
